import { getPersonLastCheckin } from './get-person-last-checkin';
export const getWentHome = (checkins) => {
    const lastCheckin = getPersonLastCheckin(checkins);
    return Boolean(lastCheckin && lastCheckin.checkoutTime !== null);
};
